import MdaSpreadsheetMappings from "../../../components/mda-spreadsheet-mappings/mda-spreadsheet-mappings";
import Page from "../../page";

const MdaSpreadsheetMappingsPage = () => {
  return (
    <Page>
      <MdaSpreadsheetMappings />
    </Page>
  );
};

export default MdaSpreadsheetMappingsPage;
